module.exports = __webpack_public_path__ + "static/img/y4.0709289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/y4.png
// module id = uH17
// module chunks = 10